var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.364 1.09091C1.66036 1.09091 1.09091 1.66036 1.09091 2.364V9.636C1.09091 10.3396 1.66036 10.9091 2.364 10.9091H9.636C10.3396 10.9091 10.9091 10.3396 10.9091 9.636V2.364C10.9091 1.66036 10.3396 1.09091 9.636 1.09091H2.364ZM0 2.364C0 1.05818 1.05818 0 2.364 0H9.636C10.9418 0 12 1.05818 12 2.364V9.636C12 10.9418 10.9418 12 9.636 12H2.364C1.73703 12 1.13574 11.7509 0.6924 11.3076C0.249064 10.8643 0 10.263 0 9.636V2.364Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7272 3.43661L14.7468 1.6857C14.7987 1.65443 14.8579 1.63729 14.9185 1.636C14.979 1.6347 15.0389 1.64928 15.0921 1.6783C15.1452 1.70732 15.1899 1.74975 15.2216 1.80139C15.2533 1.85302 15.2709 1.91205 15.2727 1.97261V10.0279C15.2727 10.2766 14.989 10.4566 14.7468 10.3159L11.7283 8.56497L11.1807 9.50861L14.1992 11.2595C15.1363 11.8028 16.3636 11.1559 16.3636 10.0279V1.97261C16.3636 0.8457 15.1363 0.198791 14.1992 0.742064L11.1818 2.49297L11.7294 3.43661H11.7272Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.0e74a1b5.svg";
export { ForwardRef as ReactComponent };